// Third-party imports
import clsx from 'clsx';

// Styles
import styles from './CustomHeaderTitle.module.scss';

interface CustomHeaderTitleProps {
    title: string;
    subtitle: string;
    promoCodeStatus: boolean;
}

const CustomHeaderTitle = ({ title, subtitle, promoCodeStatus }: CustomHeaderTitleProps) => {
    const isActive = promoCodeStatus ? 'Active' : 'Inactive';
    return (
        <div className={styles.customHeaderContainer}>
            <div className={styles.customHeader}>
                <h2 className={styles.customHeaderTitle}>{title}</h2>
                <div>
                    {promoCodeStatus && (
                        <span className={clsx(styles.customHeaderBadge, styles.activeBadge)}>{isActive}</span>
                    )}
                    {!promoCodeStatus && (
                        <span className={clsx(styles.customHeaderBadge, styles.inactiveBadge)}>{isActive}</span>
                    )}
                </div>
            </div>
            {subtitle && <div className={styles.customHeaderSubtitle}>{subtitle}</div>}
        </div>
    );
};

export default CustomHeaderTitle;
